'use strict';

function LoanApplicationBanking() {
  var _this2 = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController, _BankController];

  this._$classes = {
    form: '.js--loan-application-bank-form',
    bankSelect: '.js--loans-bankinfo-bankname',
    bankBtn: '.js--bank-btn',
    nextBtn: '.js--next',
    prevBtn: '.js--previous'
  };

  this._bankDropDownReady = $.Deferred();

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    // get Path first , used in the destroy method
    this._loanApplicationPath = this._loanApplications[0].getModelPath();
    this._bankIdReference = this._loanApplications[0].getBankIdReference();
    this._canUpdate = this._loanApplications[0].hasSubmittedBankAccount();
    this._loanApplicationStatus = this._loanApplications[0].getStatus();

    this._$node = $(this.node);
    this._$form = this._$node.find(this._$classes.form);
    this._$nextBtn = this._$node.find(this._$classes.nextBtn);
    this._$prevBtn = this._$node.find(this._$classes.prevBtn);
    this._$bankSelect = this._$node.find(this._$classes.bankSelect);
    this._$bankBtn = this._$node.find(this._$classes.bankBtn);

    this._pushPageAnalytics();
    this._attachDataAnalytics();
    this.getBankList(this._createBanksList.bind(this));

    // Wait for banklist to be completed to avoid snap in of submitted variable
    $.when(this._bankDropDownReady).done(function () {
      _this._setupEventHandlers();
      _this._preSelectIcons();
      _this._setupForm();
      _this._removeProgressLoader();
    });
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._setupForm = function () {
    // Inserts data-action link to form
    if (this._canUpdate) {
      this._teardownFn = this._loanApplications[0].updateBank(this._$form[0], {
        success: this._onBankAccountSuccess.bind(this),
        failure: this._onBankAccountFailure.bind(this)
      });
    } else {
      this._teardownFn = this._loanApplications[0].addBank(this._$form[0], {
        success: this._onBankAccountSuccess.bind(this),
        failure: this._onBankAccountFailure.bind(this)
      });
    }
  };

  this._preSelectIcons = function () {
    if (_this2._loanApplications[0].getBankId()) {
      var bankId = _this2._loanApplications[0].getBankId();
      _this2._$bankBtn.filter(function (index, element) {
        return $(element).data('bank-id') === parseInt(bankId);
      }).addClass('selected');
    }
  };

  this._setupEventHandlers = function () {
    var _this3 = this;

    this._$prevBtn.on('click', function (e) {
      e.preventDefault();
      _this3._history.goToUrl(_this3.paths.loans.application_flow_bank_introduction);
    });

    this._$bankBtn.on('click', function (e) {
      var bankId = $(e.currentTarget).data('bank-id');
      _this3._$bankBtn.removeClass('selected');
      $(e.currentTarget).addClass('selected');

      // Auto select the drop down
      _this3._$bankSelect.mogo().val(bankId);
    });

    this._$bankSelect.change(function (e) {
      var bankId = $(e.currentTarget).val();
      _this3._$bankBtn.removeClass('selected');

      // select the quick pick icons
      _this3._$bankBtn.filter(function (index, element) {
        return $(element).data('bank-id') === parseInt(bankId);
      }).addClass('selected');
    });
  };

  this._attachDataAnalytics = function () {
    this._$bankBtn.each(function (index, element) {
      var bankName = $(element).data('bank-name').split('/')[0].trim();

      $(element).attr('data-analytics-id', 'Money-Quick Pick-' + bankName + '-Navigation-Component');
    });

    // submit button button analytics id.
    var dataAnalyticsId = this._loanApplicationStatus === 'relink' ? 'Relink-Form' : 'Select-Form';
    this._$nextBtn.attr('data-analytics-id', 'Money-Loan Application Bank ' + dataAnalyticsId + ' attempt-null-SubmitClick');
  };

  this._onBankAccountSuccess = function (data, response) {
    this._$nextBtn.mogo().setDisabledLoadState();
    this._submitFormAnalytics();

    // Submit SOA, analytics once.
    if (!this._canUpdate) {
      this._submitCompletionAnalytics();
    }

    // Check if bank is online/supported by Plaid
    this._checkBankStatus();
  };

  this._checkBankStatus = function () {
    var bankId = this._loanApplications[0].getBankId();

    // BankStatusCheck returns 1 of the three below
    var onBankStatusCheckCallBack = {};
    onBankStatusCheckCallBack.onStatusNotSupported = this._onNotSupportedCallback.bind(this);
    onBankStatusCheckCallBack.onStatusOnline = this._onSupportedCallback.bind(this);
    onBankStatusCheckCallBack.onStatusOffline = this._onNotSupportedCallback.bind(this);

    if (bankId) {
      // Bank Controller method
      this.bankPlaidStatusCheck(bankId, onBankStatusCheckCallBack);
    }
  };

  this._onNotSupportedCallback = function () {
    // Update ABS_status to `not_supported` to notify BE/CRM
    var payLoad = {};
    payLoad.abs_status = 'not_supported';
    this._loanApplications[0].updateBankStatus(payLoad, {
      success: this._onUpdateStatusSuccess.bind(this),
      failure: this._onBankAccountFailure.bind(this)
    });
  };

  this._onUpdateStatusSuccess = function (data, response) {
    $('#LoanApplicationTray').mogo()._loanAppSetStepComplete();
    this._history.goToUrl(this.paths.loans.application_flow_complete);
  };

  this._onSupportedCallback = function (data, response) {
    this._history.goToUrl(this.paths.loans.application_flow_connect_bank);
  };

  this._onBankAccountFailure = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      this._$nextBtn.mogo().removeDisabledLoadState();

      this.analytics.pushEvent('loan-application-submission', {
        submission: ['Failure']
      });

      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });

      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.msg));
      });
    }
  };

  this._createBanksList = function () {
    var supportedBanks = [];
    var otherBanks = [];
    var sortedBanks = [];
    var formattedBanks = [];

    this._bankListModel = this.presenter.models.banking.banks;

    // find supported banks and put in to banksList Array
    this._bankListModel.banks.forEach(function (element) {
      // supported banks
      if (element.is_plaid_supported) supportedBanks.push(element);else otherBanks.push(element);
    });

    sortedBanks = otherBanks.sort(function (a, b) {
      return a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1;
    });

    formattedBanks = supportedBanks.concat(sortedBanks);

    for (var i = 0; i < formattedBanks.length; i++) {
      var bank = formattedBanks[i];
      // isLast value is added as the 4th argument in select.addOption,
      // if this value is true then "noReindex", sort at the last item
      // Avoid sorting the list all the time
      var isLast = i === formattedBanks.length - 1;
      this._$bankSelect.mogo().addOption(bank.name, bank.id, false, isLast);
      // put the institute number on the option tag
      $(this._$bankSelect[0][i + 1]).attr('data-institute', bank.number);
    }

    // add the data-bind to select dropdown,
    // we don't want model references in the pug,
    // using extendViewMap to convert string to integer,
    // which is why addComputedVariable is not used
    this._$bankSelect.attr('data-bind', this._bankIdReference);
    // Scan dom because dynamically generated
    this.presenter.scanDOM(this._$node);

    this._bankDropDownReady.resolve();
  };

  this.destroy = function () {
    this._super();

    // Tear down function first
    if (this._teardownFn) {
      this._teardownFn();
    }

    // Reset Model and selected if user has not submitted
    if (this._loanApplicationPath) {
      this.presenter.resetModels(this._loanApplicationPath);
      this._$bankBtn.removeClass('selected');
    }
  };

  // analytics
  this._submitFormAnalytics = function () {
    var _this4 = this;

    if (this.presenter.getModelProperty('money._loanApplicationRelink')) {
      this.analytics.forcePushEvent('form-submit', {
        FormID: ['Money-Form Submission-Loan Application Bank Select Relink-null-Form']
      });
    } else {
      this.analytics.forcePushEvent('form-submit', {
        FormID: ['Money-Form Submission-Loan App Bank Select-null-Form']
      });
    }

    this.analytics.pushEvent('loan-application-submission', {
      submission: ['Success']
    });

    // Banking, from bank controller
    var bankId = this._loanApplications[0].getBankId();
    this.getBankById(bankId, function (bankObj) {
      // Bank Controller method
      var bankName = bankObj.getBankName();
      _this4.analytics.forcePushEvent('field-selected', {
        fieldSubmittedName: ['Bank'],
        fieldSubmittedValue: [bankName]
      });
    });
  };

  this._pushPageAnalytics = function () {
    var url = window.location.pathname + (this.presenter.getModelProperty('money._loanApplicationRelink') ? '-relink' : '');

    this.analytics.forcePushEvent('virtual-page-view', {
      Page: [url]
    });
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._submitCompletionAnalytics = function () {
    // Send soa_env.analytics, on loan application submitted once.
    if (this._activeOffer.getOfferType() !== 'level_up') {
      var analyticsData = this.analytics.constructData('Liquid Digital Application Submitted');
      var analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);
      analyticsRequest.send();
    }
  };
}